import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"
import _ from "lodash"

const get = function ($, projectId, nonConformityId = null) {
  return new Promise((resolve, reject) => {
    HTTP.get(
      `/projects/${
        nonConformityId ? "non-conformities/" + nonConformityId : projectId + "/non-conformities"
      }`
    )
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getAllNonConformities = function () {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/non-conformities`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getListAllActions = function () {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/non-conformities/actions`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getListAllProjectActions = function (projectId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${projectId}/non-conformities/actions`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getByInspection = function (projectId, inspectionId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/${projectId}/inspections/${inspectionId}/non-conformities`)
      .then(response => {
        resolve(response.data)
      })
      .catch(exception => {
        reject(exception)
      })
  })
}

const create = function ($, projectId, inspectionId, nonConformity) {
  if (_.isObject(nonConformity.inspection)) {
    nonConformity.inspection = nonConformity.inspection.pk
  }

  return new Promise((resolve, reject) => {
    HTTP.post(`projects/${projectId}/inspections/${inspectionId}/non-conformities`, nonConformity)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const update = function ($, nonConformityId, data) {
  return new Promise((resolve, reject) => {
    HTTP.patch(`/projects/non-conformities/${nonConformityId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, nonConformityId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/projects/non-conformities/${nonConformityId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const close = function ($, nonConformityId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/non-conformities/${nonConformityId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const closeAction = function ($, actionId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/non-conformities/action/${actionId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const createAction = function (nonConformityId, data) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/non-conformities/${nonConformityId}/action`, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const createProjectAction = function (projectId, data) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/action-project/${projectId}/action`, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const getAction = function (actionId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/non-conformities/action/${actionId}`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getAllActions = function (nonConformityId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/non-conformities/${nonConformityId}/action`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const updateAction = function (actionID, data) {
  return new Promise((resolve, reject) => {
    HTTP.put(`projects/non-conformities/action/${actionID}`, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const deleteAction = function (actionID) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`projects/non-conformities/action/${actionID}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        if (err.response && err.response.status === 403) {
          // alert("Access denied: You do not have permission to access this resource.")
          this.$store.commit("app/message", {
            msg: this.$t("messages.error.permission_denied"),
            color: "error"
          })
        } else {
          reject(err)
        }
      })
  })
}

const getSignatures = function (nonConformityId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/non-conformities/${nonConformityId}/signatures`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const postSignature = function (nonConformityId, imageData) {
  if (imageData) {
    const formData = new FormData()
    formData.append("image", imageData)

    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/non-conformities/${nonConformityId}/signatures`, formData)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  } else {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/non-conformities/${nonConformityId}/signatures`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getActionSignatures = function (actionId) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/projects/non-conformities/action/${actionId}/signatures`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const postActionSignature = function (actionId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/projects/non-conformities/action/${actionId}/signatures`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

// const close = function ($, nonConformityId) {
//   return new Promise((resolve, reject) => {
//     HTTP.post(`projects/non-conformities/${nonConformityId}/close`)
//       .then(response => resolve(response.data))
//       .catch(err => {
//         return reject(err)
//       })
//   })
// }

export default {
  get,
  getAllNonConformities,
  getListAllActions,
  getListAllProjectActions,
  getByInspection,
  create,
  update,
  remove,
  close,
  closeAction,
  createAction,
  createProjectAction,
  getAllActions,
  updateAction,
  deleteAction,
  postSignature,
  getSignatures,
  postActionSignature,
  getActionSignatures,
  getAction
}
